import apiClient from './apiClient';

export interface AccessEntry {
  id: number;
  user_id: number;
  role: string;
  granted_by?: number;
  created_at?: string;
  user?: {
    id: number;
    login: string;
    firstname: string;
    lastname: string;
    admin: number;
  } | null;
}

export interface GrantAccessPayload {
  email: string;
  role: string;
}

class AccessService {
  async list(): Promise<AccessEntry[]> {
    const response = await apiClient.get<{ success: boolean; data: AccessEntry[] }>('/admin/access');
    return response.data.data;
  }

  async grant(payload: GrantAccessPayload): Promise<AccessEntry> {
    const response = await apiClient.post<{ success: boolean; data: AccessEntry }>('/admin/access', payload);
    return response.data.data;
  }

  async revoke(role: string, userId: number): Promise<void> {
    await apiClient.delete(`/admin/access/${role}/${userId}`);
  }
}

export default new AccessService();

